import { render, staticRenderFns } from "./ModelButtonOverview.vue?vue&type=template&id=59c40d8d&scoped=true"
import script from "./ModelButtonOverview.vue?vue&type=script&lang=js"
export * from "./ModelButtonOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c40d8d",
  null
  
)

export default component.exports